import React, { useEffect} from "react";

export function useClickOutside<T extends HTMLElement>(
  ref: React.RefObject<T>,
  isOpen: boolean,
  onClose: () => void,
  ignoredRef?: React.RefObject<HTMLElement>
) {
  useEffect(() => {
    if (!isOpen) return;

    const handle = (event: MouseEvent) => {
      const node = ref.current;
      const target = event.target as Node;
      if (!node) return;
      if (ignoredRef?.current?.contains(target)) return;
      if (!node.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handle);
    return () => {
      document.removeEventListener("mousedown", handle);
    };
  }, [isOpen, onClose, ref]);
}
